export default function InternalLinks() {
  return (
    <section className="bg-white py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#1E3A47] mb-3">
            Explorez nos autres pages
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
          <a
            href="/"
            className="group bg-[#EEF2F4] rounded-2xl border border-[#D7E0E4] p-6 md:p-8 text-center hover:border-[#FF6B4A]/40 transition-colors"
          >
            <div className="w-12 h-12 rounded-xl bg-[#1E3A47]/10 flex items-center justify-center mx-auto mb-4 group-hover:bg-[#FF6B4A]/10 transition-colors">
              <i className="ri-home-4-line text-[#1E3A47] text-xl w-8 h-8 flex items-center justify-center" />
            </div>
            <h3 className="text-lg font-semibold text-[#1E3A47] mb-2">Accueil</h3>
            <p className="text-sm text-[#243038]">Réparation de fenêtre à Strasbourg et dans le Bas-Rhin.</p>
          </a>
          <a
            href="/zones-dinterventions"
            className="group bg-[#EEF2F4] rounded-2xl border border-[#D7E0E4] p-6 md:p-8 text-center hover:border-[#FF6B4A]/40 transition-colors"
          >
            <div className="w-12 h-12 rounded-xl bg-[#1E3A47]/10 flex items-center justify-center mx-auto mb-4 group-hover:bg-[#FF6B4A]/10 transition-colors">
              <i className="ri-map-2-line text-[#1E3A47] text-xl w-8 h-8 flex items-center justify-center" />
            </div>
            <h3 className="text-lg font-semibold text-[#1E3A47] mb-2">Zones d'intervention</h3>
            <p className="text-sm text-[#243038]">Découvrez toutes les villes où nous intervenons.</p>
          </a>
          <a
            href="/reparation-fenetre-ostwald"
            className="group bg-[#EEF2F4] rounded-2xl border border-[#D7E0E4] p-6 md:p-8 text-center hover:border-[#FF6B4A]/40 transition-colors"
          >
            <div className="w-12 h-12 rounded-xl bg-[#1E3A47]/10 flex items-center justify-center mx-auto mb-4 group-hover:bg-[#FF6B4A]/10 transition-colors">
              <i className="ri-arrow-right-line text-[#1E3A47] text-xl w-8 h-8 flex items-center justify-center" />
            </div>
            <h3 className="text-lg font-semibold text-[#1E3A47] mb-2">Réparation Ostwald</h3>
            <p className="text-sm text-[#243038]">Service de réparation de fenêtre à Ostwald.</p>
          </a>
        </div>
      </div>
    </section>
  );
}